import React from "react";
import type {
  Habit,
  EditableHabit,
  FreeformEditableHabit,
  MultiDayEditableHabit,
  SingleSiteEditableHabit,
} from "../types";
import FreeformHabitForm from "./FreeformHabitForm";
import MultiDayHabitForm from "./MultiDayHabitForm";
import SingleSiteHabitForm from "./SingleSiteHabitForm";
import { useNavigate } from "react-router-dom";

export type StateProps = {};
export type DispatchProps = {
  updateHabit: (arg0: Habit, arg1: EditableHabit, arg2: () => void) => void;
};
export type OwnProps = {
  habit: Habit;
  isOwner: boolean;
};
export type Props = StateProps & DispatchProps & OwnProps;
export default function EditHabit(props: Props) {
  const nav = useNavigate();

  const onSave = (editableHabit: EditableHabit, install: boolean) => {
    props.updateHabit(props.habit, editableHabit, () => {
      nav("/manage");
    });
  };

  // fixme
  const { habit, ...otherProps } = props;
  const editableHabit: EditableHabit = habit as any;

  switch (editableHabit.type) {
    case "freeform":
      return (
        <FreeformHabitForm
          habit={editableHabit as FreeformEditableHabit}
          onSave={onSave}
          {...otherProps}
        />
      );

    case "multi-day":
      return (
        <MultiDayHabitForm
          habit={editableHabit as MultiDayEditableHabit}
          onSave={onSave}
          {...otherProps}
        />
      );

    case "single-site":
      return (
        <SingleSiteHabitForm
          habit={editableHabit as SingleSiteEditableHabit}
          onSave={onSave}
          {...otherProps}
        />
      );
  }

  // editing not supported
  return null;
}
